import React from 'react';
import { 
  Box,
  Paper,
  Typography,
  Button,
  Alert,
  AlertTitle,
  Stack
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Link } from 'react-router-dom';

interface ErrorDisplayProps {
  message?: string;
  error?: Error;
  onRetry?: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ 
  message = 'An error occurred',
  error,
  onRetry
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'error.light',
        bgcolor: 'error.lightest',
        maxWidth: '100%',
        mx: 'auto',
        my: 4
      }}
    >
      <Stack spacing={3} alignItems="center">
        <ErrorOutlineIcon color="error" sx={{ fontSize: 64 }} />
        
        <Typography variant="h5" component="h2" align="center" gutterBottom>
          {message}
        </Typography>
        
        {error && process.env.NODE_ENV === 'development' && (
          <Alert severity="error" sx={{ width: '100%' }}>
            <AlertTitle>Error Details</AlertTitle>
            <Typography variant="body2" component="pre" sx={{ overflowX: 'auto' }}>
              {error.message}
            </Typography>
            {error.stack && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="caption" component="pre" sx={{ overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
                  {error.stack}
                </Typography>
              </Box>
            )}
          </Alert>
        )}
        
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          {onRetry && (
            <Button
              variant="contained"
              color="primary"
              onClick={onRetry}
            >
              Try Again
            </Button>
          )}
          
          <Button
            variant="outlined"
            component={Link}
            to="/"
          >
            Return to Homepage
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default ErrorDisplay; 